import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ArticlePath, createGuideLink, FeatureFlag, RouteName } from '@mews-commander/enums';
import { BackendPage, getBackendPageUrl } from '@mews-commander/modules';
import { VouchersOverviewTable } from '@mews-commander/modules/src/modules/vouchers';
import { MewsTeam, RouteType } from '@mews/enums';
import { useFeatureFlag } from '@mews/framework';

const Component = () => {
    const { pathname, search } = Route.useMatch();

    return useFeatureFlag(FeatureFlag.vouchersFETablePMSEnabled) ? (
        <VouchersOverviewTable serviceId={search.OwnerId} />
    ) : (
        <BackendPage url={getBackendPageUrl({ pathname, search })} />
    );
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Voucher/Index/')({
    component: Component,
    staticData: {
        routeName: RouteName.VoucherIndex,
        owner: MewsTeam.RevenueServices,
        type: RouteType.Backend,
        guideLink: createGuideLink(ArticlePath.CreateVoucher),
    },
    validateSearch: z.object({
        OwnerId: z.string().uuid(),
    }),
});
